<template>
    <div class="section" :id="sectionId">
        <SectionLabel :sectionNo="sectionNo"
                      :label="label"
                      :title="title">
        </SectionLabel>
        <slot></slot>
    </div>
</template>

<script>
import SectionLabel from "./SectionLabel.vue";

export default {
    name: 'SiteSection',
    props: [ "sectionId", "sectionNo", "label", "title" ],
    components: {
        SectionLabel
    },
}
</script>

<style scoped 
       lang="scss">
    @import "../../static/styles/palette.scss";

    .section {
        padding-top: 120px;
        overflow-x: hidden;
    }

    @media all and (max-width: 768px) {
        .section {
            padding-top: 80px;
        }      
    }
</style>



// WEBPACK FOOTER //
// Section.vue?3b6f206e